export enum AuthActionType {
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  LOGOUT = 'LOGIN_LOGOUT'
};

export enum LoadingActionType {
  LOAD = 'LOADING_START',
  ENDLOAD = 'LOADING_END',
  LOADINGPAGE_DISPLAY = 'LOADINGPAGE_DISPLAY',
  LOADINGPAGE_HIDE = 'LOADINGAGE_HIDE',
};

export enum AlertActionType {
  SUCCESS = 'ALERT_SUCCESS',
  ERROR = 'ALERT_ERROR',
  WARNING = 'ALERT_WARNING',
  INFO = 'ALERT_INFO',
  CLEAR = 'ALERT_CLEAR'
};
